import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import { ControlStyled } from 'components/Select/Select.styled';

export const TicketsStatusSelectStyled = styled.div`
  position: relative;
  left: -6px;
  cursor: pointer;

  span[class$='-indicatorSeparator'] {
    display: none;
  }
  div[id$='-listbox'] {
    position: absolute;
    width: 120px;
  }

  div[class$='-indicatorContainer'] {
    padding: 2px;
    width: 16px;
  }

  div[class^='Selectstyled__ControlStyled-'] > div:first-child {
    padding: 0;
    text-align: right;
  }

  ${ControlStyled} {
    min-width: 36px;
  }
`;
export const FlexContainerStyled = styled(FlexContainer)`
  padding: 2rem;
`;
